import { render, staticRenderFns } from "./blogPage.vue?vue&type=template&id=271c69b1&"
import script from "./blogPage.vue?vue&type=script&lang=js&"
export * from "./blogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports